import type { IGetProductsQuery } from "@magento/types/CodegenTypes";
import { ICurrencyEnum, IProductStockStatus } from "@magento/types/CodegenTypes";

export const getBundleProductResponseMock = (): IGetProductsQuery => ({
  currency: {
    base_currency_code: ICurrencyEnum.Eur,
    base_currency_symbol: "€",
  },
  products: {
    aggregations: [],
    items: [
      {
        sku: "sticks-mix-n-match-subscription",
        __typename: "BundleProduct",
        id: 13617,
        product_disclaimer: "",
        flavor_label: "Test Flavor",
        name: "Carton Mix'n'Match - subscription",
        stock_status: IProductStockStatus.InStock,
        subtitle: "",
        categories: [],
        price_tiers: [],
        flavor: 0,
        product_brand: "1",
        color: 0,
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/static/version1732026409/frontend/Magento/luma/en_US/Magento_Catalog/images/product/placeholder/thumbnail.jpg",
        },
        price_range: {
          minimum_price: {
            final_prices: [
              {
                value: 321.98,
                currency: ICurrencyEnum.Eur,
                multiplier: 1,
              },
              {
                value: 643.96,
                currency: ICurrencyEnum.Eur,
                multiplier: 2,
              },
              {
                value: 965.94,
                currency: ICurrencyEnum.Eur,
                multiplier: 3,
              },
              {
                value: 1287.92,
                currency: ICurrencyEnum.Eur,
                multiplier: 4,
              },
              {
                value: 1609.9,
                currency: ICurrencyEnum.Eur,
                multiplier: 5,
              },
            ],
            final_price: {
              value: 321.98,
              currency: ICurrencyEnum.Eur,
            },
            regular_price: {
              value: 321.98,
              currency: ICurrencyEnum.Eur,
            },
            discount: {
              percent_off: 0,
            },
          },
        },
        items: [
          {
            option_id: 4655,
            title: "sticks",
            required: true,
            type: "multi",
            qty: 10,
            __typename: "BundleItem",
            sku: "sticks-mix-n-match-subscription",
            all_options: [
              {
                id: 4745,
                label: "Camel Bronze - pack",
                qty: 1,
                quantity: 1,
                is_default: false,
                product: {
                  id: 13598,
                  name: "Camel Bronze - pack",
                  sku: "sticks-pack-bronze",
                  product_brand: "1",
                  flavor: 14,
                  flavor_label: "Bronze",
                  stock_status: IProductStockStatus.InStock,
                  color_label: "",
                  subtitle: "subtitle",
                  flavour_details: [
                    {
                      name: "Silver",
                      description: "Fresh kick",
                      attributes: [
                        {
                          id: 9,
                          name: "Intensity",
                          sort_order: 17,
                          value: "4.5",
                        },
                        {
                          id: 10,
                          name: "Flavor",
                          sort_order: 18,
                          value: "1.5",
                        },
                        {
                          id: 11,
                          name: "Strength",
                          sort_order: 19,
                          value: "2.5",
                        },
                      ],
                    },
                  ],
                  thumbnail: {
                    url: "https://m24-fe1.dev-jtides.com/static/version1732026409/frontend/Magento/luma/en_US/Magento_Catalog/images/product/placeholder/thumbnail.jpg",
                  },
                  media_gallery: [
                    {
                      label: "",
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/b/r/bronze.jpg",
                      role: [],
                    },
                    {
                      label: "",
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_bronze.png",
                      role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
                    },
                    {
                      label: "",
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_bronze_2.png",
                      role: [],
                    },
                  ],
                  categories: [],
                  price_range: {
                    minimum_price: {
                      final_price: {
                        value: 3.5,
                        currency: ICurrencyEnum.Eur,
                      },
                      regular_price: {
                        value: 11.11,
                        currency: ICurrencyEnum.Eur,
                      },
                      discount: {
                        percent_off: 68.5,
                      },
                    },
                  },
                  __typename: "SimpleProduct",
                },
              },
              {
                id: 4746,
                label: "Camel Gold - pack",
                qty: 1,
                quantity: 1,
                is_default: false,
                product: {
                  id: 13600,
                  name: "Camel Gold - pack",
                  sku: "sticks-pack-gold",
                  flavor: 13,
                  flavor_label: "Gold",
                  product_brand: "1",
                  subtitle: "subtitle",
                  stock_status: IProductStockStatus.InStock,
                  color_label: "",
                  flavour_details: [
                    {
                      name: "Bronze",
                      description: "Smoother than you think",
                      attributes: [
                        {
                          id: 1,
                          name: "Intensity",
                          sort_order: 3,
                          value: "2.5",
                        },
                        {
                          id: 2,
                          name: "Flavor",
                          sort_order: 4,
                          value: "5",
                        },
                      ],
                    },
                  ],
                  thumbnail: {
                    url: "https://m24-fe1.dev-jtides.com/static/version1732026409/frontend/Magento/luma/en_US/Magento_Catalog/images/product/placeholder/thumbnail.jpg",
                  },
                  media_gallery: [
                    {
                      label: "",
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/2/_/2_1.jpg",
                      role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
                    },
                  ],
                  categories: [],
                  price_range: {
                    minimum_price: {
                      final_price: {
                        value: 22.22,
                        currency: ICurrencyEnum.Eur,
                      },
                      regular_price: {
                        value: 22.22,
                        currency: ICurrencyEnum.Eur,
                      },
                      discount: {
                        percent_off: 0,
                      },
                    },
                  },
                  __typename: "SimpleProduct",
                },
              },
              {
                id: 4747,
                label: "Camel Silver - Pack",
                qty: 1,
                quantity: 1,
                is_default: false,
                product: {
                  id: 13601,
                  name: "Camel Silver - Pack",
                  sku: "sticks-pack-silver",
                  product_brand: "1",
                  flavor: 15,
                  flavor_label: "Silver",
                  stock_status: IProductStockStatus.InStock,
                  color_label: "",
                  subtitle: "subtitle",
                  flavour_details: [
                    {
                      name: "Gold",
                      description: "Rich as Bezos",
                      attributes: [
                        {
                          id: 5,
                          name: "Intensity",
                          sort_order: 8,
                          value: "4.5",
                        },
                        {
                          id: 6,
                          name: "Flavor",
                          sort_order: 9,
                          value: "1.5",
                        },
                        {
                          id: 7,
                          name: "Strength",
                          sort_order: 10,
                          value: "4.5",
                        },
                      ],
                    },
                  ],
                  thumbnail: {
                    url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/3/_/3_2_1.jpg",
                  },
                  media_gallery: [
                    {
                      label: "",
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/3/_/3.jpg",
                      role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
                    },
                    {
                      label: "",
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
                      role: [],
                    },
                  ],
                  categories: [],
                  price_range: {
                    minimum_price: {
                      final_price: {
                        value: 33.33,
                        currency: ICurrencyEnum.Eur,
                      },
                      regular_price: {
                        value: 33.33,
                        currency: ICurrencyEnum.Eur,
                      },
                      discount: {
                        percent_off: 0,
                      },
                    },
                  },
                  __typename: "SimpleProduct",
                },
              },
              {
                id: 4748,
                label: "Camel Amber - Pack",
                qty: 1,
                quantity: 1,
                is_default: false,
                product: {
                  id: 13604,
                  name: "Camel Amber - Pack",
                  sku: "sticks-pack-amber",
                  flavor: 16,
                  flavor_label: "Amber",
                  product_brand: "1",
                  subtitle: "subtitle",
                  stock_status: IProductStockStatus.InStock,
                  flavour_details: [
                    {
                      name: "Silver",
                      description: "Fresh kick",
                      attributes: [
                        {
                          id: 9,
                          name: "Intensity",
                          sort_order: 17,
                          value: "4.5",
                        },
                        {
                          id: 10,
                          name: "Flavor",
                          sort_order: 18,
                          value: "1.5",
                        },
                        {
                          id: 11,
                          name: "Strength",
                          sort_order: 19,
                          value: "2.5",
                        },
                      ],
                    },
                  ],
                  color_label: "",
                  thumbnail: {
                    url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/4/_/4_2.jpg",
                  },
                  media_gallery: [
                    {
                      label: "",
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/4/_/4_1.jpg",
                      role: [],
                    },
                    {
                      label: "",
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_amber.png",
                      role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
                    },
                  ],
                  categories: [],
                  price_range: {
                    minimum_price: {
                      final_price: {
                        value: 44.44,
                        currency: ICurrencyEnum.Eur,
                      },
                      regular_price: {
                        value: 44.44,
                        currency: ICurrencyEnum.Eur,
                      },
                      discount: {
                        percent_off: 0,
                      },
                    },
                  },
                  __typename: "SimpleProduct",
                },
              },
              {
                id: 4749,
                label: "Camel Tan - Pack",
                qty: 1,
                quantity: 1,
                is_default: false,
                product: {
                  id: 13606,
                  name: "Camel Tan - Pack",
                  sku: "sticks-pack-tan",
                  product_brand: "1",
                  flavor: 37,
                  flavor_label: "Tan",
                  subtitle: "subtitle",
                  stock_status: IProductStockStatus.InStock,
                  color_label: "",
                  flavour_details: [
                    {
                      name: "Amber",
                      description: "Stronger fresh kick",
                      attributes: [
                        {
                          id: 13,
                          name: "Intensity",
                          sort_order: 22,
                          value: "0.5",
                        },
                        {
                          id: 14,
                          name: "Flavor",
                          sort_order: 23,
                          value: "4.5",
                        },
                        {
                          id: 15,
                          name: "Strength",
                          sort_order: 24,
                          value: "2.5",
                        },
                      ],
                    },
                  ],
                  thumbnail: {
                    url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_tan.png",
                  },
                  media_gallery: [
                    {
                      label: "",
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/5/_/5.jpg",
                      role: [],
                    },
                    {
                      label: "",
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_tan.png",
                      role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
                    },
                  ],
                  categories: [],
                  price_range: {
                    minimum_price: {
                      final_price: {
                        value: 55.55,
                        currency: ICurrencyEnum.Eur,
                      },
                      regular_price: {
                        value: 55.55,
                        currency: ICurrencyEnum.Eur,
                      },
                      discount: {
                        percent_off: 0,
                      },
                    },
                  },
                  __typename: "SimpleProduct",
                },
              },
              {
                id: 4750,
                label: "Camel Burgundy - pack",
                qty: 1,
                quantity: 1,
                is_default: false,
                product: {
                  id: 13608,
                  name: "Camel Burgundy - pack",
                  sku: "sticks-pack-burgundy",
                  subtitle: "subtitle",
                  product_brand: "1",
                  flavour_details: [
                    {
                      name: "Burgundy",
                      description: "Bloody Mary",
                      attributes: [
                        {
                          id: 21,
                          name: "Intensity",
                          sort_order: 32,
                          value: "4.5",
                        },
                        {
                          id: 22,
                          name: "Flavor",
                          sort_order: 33,
                          value: "3.5",
                        },
                        {
                          id: 23,
                          name: "Strength",
                          sort_order: 34,
                          value: "3",
                        },
                      ],
                    },
                  ],
                  thumbnail: {
                    url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_burgundy.png",
                  },
                  flavor: 40,
                  flavor_label: "Burgundy",
                  stock_status: IProductStockStatus.OutOfStock,
                  color_label: "",
                  media_gallery: [
                    {
                      label: "",
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/6/_/6.jpg",
                      role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
                    },
                  ],
                  categories: [],
                  price_range: {
                    minimum_price: {
                      final_price: {
                        value: 66.66,
                        currency: ICurrencyEnum.Eur,
                      },
                      regular_price: {
                        value: 66.66,
                        currency: ICurrencyEnum.Eur,
                      },
                      discount: {
                        percent_off: 0,
                      },
                    },
                  },
                  __typename: "SimpleProduct",
                },
              },
            ],
          },
        ],
        media_gallery: [],
        flavour_details: [],
      },
    ],
  },
});
